/*------------------------------------*\
    measurements from fm
\*------------------------------------*/
module.exports = function(){



    if (Cookies.get('FM_EPH_CONVERSION_ID')) {
        console.info('Converting FM signup: ' + Cookies.get('FM_EPH_CONVERSION_ID'))
        eph.tagGetFittedCustomer(globalOmsCustomerId)
    }


    if (Cookies.get('FM_EPH_MEASUREMENTS')) {
        var raw_measurements = JSON.parse( Cookies.get('FM_EPH_MEASUREMENTS') );
        var measurements_with_int_ids = [];


        var weekday = [];
        weekday[0] = 'Sunday';
        weekday[1] = 'Monday';
        weekday[2] = 'Tuesday';
        weekday[3] = 'Wednesday';
        weekday[4] = 'Thursday';
        weekday[5] = 'Friday';
        weekday[6] = 'Saturday';
        var now = new Date();
        //var currentDateName =   'FM - ' + weekday[now.getDay()] + ', ' +
        //                        String(now.getDate()) + '.' +
        //                        String(now.getMonth()) + '.' +
        //                        String(now.getFullYear());
        var profileName = 'FM - ' + now.toDateString();


        for (var meastype in raw_measurements) {
            var value = raw_measurements[meastype];

            switch (meastype) {
                case 'Weight':
                    measurements_with_int_ids.push({typeId: 1, value: value});
                    break;
                case 'Height':
                    measurements_with_int_ids.push({typeId: 2, value: value});
                    break;
                case 'Neck':
                    measurements_with_int_ids.push({typeId: 3, value: value});
                    break;
                case 'Shoulder':
                    measurements_with_int_ids.push({typeId: 4, value: value});
                    break;
                case 'SleeveLength':
                    measurements_with_int_ids.push({typeId: 5, value: value});
                    break;
                case 'ShirtLength':
                    measurements_with_int_ids.push({typeId: 6, value: value});
                    break;
                case 'Chest':
                    measurements_with_int_ids.push({typeId: 7, value: value});
                    break;
                case 'StomachUp':
                    measurements_with_int_ids.push({typeId: 8, value: value});
                    break;
                case 'StomachDown':
                    measurements_with_int_ids.push({typeId: 9, value: value});
                    break;
                case 'Bicep':
                    measurements_with_int_ids.push({typeId: 10, value: value});
                    break;
                case 'Forearm':
                    measurements_with_int_ids.push({typeId: 11, value: value});
                    break;
                case 'Wrist':
                    measurements_with_int_ids.push({typeId: 12, value: value});
                    break;
                case 'Waist':
                    measurements_with_int_ids.push({typeId: 13, value: value});
                    break;
                case 'Crotch':
                    measurements_with_int_ids.push({typeId: 14, value: value});
                    break;
                case 'Thigh':
                    measurements_with_int_ids.push({typeId: 15, value: value});
                    break;
                case 'Hips':
                    measurements_with_int_ids.push({typeId: 16, value: value});
                    break;
                case 'Knee':
                    measurements_with_int_ids.push({typeId: 17, value: value});
                    break;
                case 'PantLength':
                    measurements_with_int_ids.push({typeId: 18, value: value});
                    break;
                case 'JacketLength':
                    measurements_with_int_ids.push({typeId: 19, value: value});
                    break;
                case 'VestLength':
                    measurements_with_int_ids.push({typeId: 20, value: value});
                    break;
                default:
                    break;
            }
        }

        var createMeasurements = function(profileId){
            measurements_with_int_ids.forEach( function(element, index) {
                eph.createMeasurement(profileId, element.typeId, element.value);
            });
        };



        eph.createMeasurementProfile({
            CustomerId: globalOmsCustomerId,
            Name: profileName,
            IsFm: true,
            success: function(data, textStatus, jqXHR){
                createMeasurements(data.Id);
                Cookies.remove('FM_EPH_MEASUREMENTS');

                alertify
                .alert('A new measurement profile has been created.', function () {

                    if (window.location.href.indexOf('/profile') > -1) {
                        window.location.reload()
                    } else {
                        window.location.href = WP_SITEURL + '/profile/#measurements';
                    }
                })
                .reset();

            },
        });
    }


    /*
        FM_EPH_MEASUREMENTS
        {%22Knee%22:13.8736,%22PantLength%22:36.3168,%22Bicep%22:10.5777,%22Wrist%22:7.4672,%22Neck%22:17.4,%22Waist%22:27.82,%22Shoulder%22:15.8841,%22ShirtLength%22:29.67,%22JacketLength%22:29.17,%22SleeveLength%22:20.56,%22Chest%22:30.88,%22StomachUp%22:27.43,%22StomachDown%22:27.06,%22Forearm%22:10.35,%22Crotch%22:26.06,%22Thigh%22:18.74,%22Hips%22:34.46,%22VestLength%22:24.67,%22Weight%22:111,%22Height%22:83}



        {"Knee":13.8736,"PantLength":36.3168,"Bicep":10.5777,"Wrist":7.4672,"Neck":17.4,"Waist":27.82,"Shoulder":15.8841,"ShirtLength":29.67,"JacketLength":29.17,"SleeveLength":20.56,"Chest":30.88,"StomachUp":27.43,"StomachDown":27.06,"Forearm":10.35,"Crotch":26.06,"Thigh":18.74,"Hips":34.46,"VestLength":24.67,"Weight":111,"Height":83}
    */






}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/measurements_from_fm.js